import { observer } from "mobx-react";
import { Button } from "../../../../../components/inputs/button/button";
import { BUTTON_VARIANTS } from "../../../../../components/inputs/button-variants";
import { IRmaReleaseExchangeAction } from "../../stores/rma-page-store";
import rmsMixpanelStore from "../../../../../stores/rms-mixpanel-store";
import IconReturnNotRefundExchange
	from "../../../../../components/icons/icon-return-not-refund-exchange/icon-return-not-refund-exchange";

interface IProps {
	releaseExchangeAction: IRmaReleaseExchangeAction;
	label: string;
	disabled: boolean;
	isLoading: boolean;
}

const ReleaseExchangeToolbarButton: React.FC<IProps> = observer(
	({releaseExchangeAction, label, disabled, isLoading}) => {
		const onClick = () => {
			rmsMixpanelStore.trackEvent("d&_rma_release_exchange_button");
			releaseExchangeAction.store?.submitAction();
		};

		return (
			<Button
				variant={BUTTON_VARIANTS.PrimaryAccent}
				leftIcon={() => <IconReturnNotRefundExchange color="var(--color-neutral-1-white)"/>}
				text={label}
				disabled={disabled}
				hasLoader={true}
				isLoading={isLoading}
				onClick={onClick}
			/>
		);
	}
);

export default ReleaseExchangeToolbarButton;
